import React from 'react';
import { Clock, MapPin, Instagram } from 'lucide-react';

const TwistPage = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background Image with Modern Gradient Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/pozadi.jpg)',
          filter: 'blur(2px)'
        }}
      >
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,0.6), rgba(0,0,0,0.7))'
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header - Logo a nadpis v levém horním rohu */}
        <header className="py-6">
          <div className="container mx-auto px-6">
            <div className="flex justify-start items-center gap-4">
              <img
                src="/logo.png"
                alt="Twist Slow Fashion"
                className="h-16 w-auto opacity-90 hover:opacity-100 transition-all duration-300 transform rotate-3"
              />
            </div>
          </div>
        </header>

        {/* Full-screen Hero Section */}
        <main className="flex-1 flex items-center justify-center px-6">
          <div className="text-center max-w-4xl mx-auto">
            {/* Main Title with Animation */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight animate-fade-in">
              Připravujeme pro Vás
            </h1>

            {/* Subtitle */}
            <p className="text-xl md:text-2xl lg:text-3xl text-gray-200 mb-12 font-light leading-relaxed animate-fade-in-delay">
              nový web Twist slow fashion
            </p>

            {/* Divider */}
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-white to-transparent mx-auto mb-16 animate-fade-in-delay-2"></div>

            {/* Message */}
            <div className="mb-16 max-w-2xl mx-auto animate-fade-in-delay-3">
              <div className="bg-white bg-opacity-10 backdrop-blur-md border border-white border-opacity-20 p-8">
                <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
                  Děkujeme za Vaši trpělivost. Naše nová webová stránka je v procesu tvorby a brzy bude připravena.
                </p>
              </div>
            </div>



            {/* CTA Section */}
            <div className="animate-fade-in-delay-6">
              <p className="text-xl md:text-2xl text-white mb-8 font-medium">
                Těšíme se na Vaši návštěvu
              </p>

              {/* Social Media Section */}
              <div className="mb-8">
                <p className="text-lg text-gray-200 mb-6">
                  Sledujte nás na sociálních sítích
                </p>

                {/* Social Media Icons */}
                <div className="flex justify-center items-center gap-6">
                  {/* Instagram Icon */}
                  <a
                    href="https://www.instagram.com/twist_slow_fashion/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group"
                  >
                    <div className="w-16 h-16 bg-gradient-to-br from-purple-700 via-pink-600 to-orange-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:shadow-2xl">
                      <Instagram className="w-8 h-8 text-white" />
                    </div>
                  </a>

                  {/* Facebook Icon */}
                  <a
                    href="https://www.facebook.com/twistslowfashion/?locale=cs_CZ"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group"
                  >
                    <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:shadow-2xl">
                      <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="py-8 mt-auto">
          <div className="container mx-auto px-6 text-center">
            <p className="text-gray-300 text-sm">
              &copy; 2019 Twist Slow Fashion
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default TwistPage;
